import React from "react";

export default function Badge({icon, label, classProp, onClick}) {
    const clickableCSS = onClick ? "clickable" : "";

    return (
        <span className={`badge ${classProp} ${clickableCSS}`} onClick={onClick}>
            {icon}
            {label}
        </span>
    )
}